import { render, staticRenderFns } from "./TabDelivery.vue?vue&type=template&id=311e5248&scoped=true&lang=pug"
import script from "./TabDelivery.vue?vue&type=script&lang=js"
export * from "./TabDelivery.vue?vue&type=script&lang=js"
import style0 from "./TabDelivery.vue?vue&type=style&index=0&id=311e5248&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "311e5248",
  null
  
)

export default component.exports